// extracted by mini-css-extract-plugin
export default {"h2":"Map_h2__MN7wT"};